import PolicyPage from "./PolicyPage";

export default function Warranty() {
    return <PolicyPage name="warranty" />;
}
